<template>
    <div
        class="rule-item"
        :class="{
            'rule-item--valid': valid
        }"
        @click="onFocusItem"
    >
        <div class="rule-item__content">
            <div class="rule-item__title">
                <rule-selector
                    :value="optionInfo.value"
                    :rule-options="ruleOptions"
                    @change-component="onChangeComponent"
                />
            </div>
            <div class="rule-item__detail">
                <component
                    :is="componentName"
                    ref="ruleContent"
                    :value="currentValue"
                    :option-info="optionInfo"
                    :data-source="cgiData"
                    @change="onChange"
                />
            </div>
            <v-tip
                ref="removeTips"
                placement="top"
            >
                <span>删除</span>
            </v-tip>
            <div
                v-tip:removeTips
                class="rule-item__btn-remove"
            >
                <v-icon
                    name="remove"
                    @click="onRemove"
                />
            </div>
        </div>
    </div>
</template>
<script>
import Bus from '@/utils/Bus.js';
import { RULE_TYPE_MAP } from '../../config';
import ruleComponents from './components/index';
import RuleSelector from '../rule-selector';

export default {
  name: 'RuleItem',

  components: {
    ...ruleComponents,
    RuleSelector,
  },
  props: {
    // 传入值
    value: {
      type: [Number, String, Array, Object],
      default() {
        return null;
      },
    },
    valid: {
      type: Boolean,
      default: false,
    },
    componentName: {
      type: String,
      default: '',
    },
    // 下拉树定义，如果是字符串则展示一个没有下拉只有名字的面板
    ruleOptions: {
      type: [Array, String],
      default() {
        return null;
      },
    },
    // 下拉树定义，如果是字符串则展示一个没有下拉只有名字的面板
    ruleConfig: {
      type: Object,
      default() {
        return null;
      },
    },
    // 当前组件在菜单中的配置
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    // 预加载数据
    preloadedData: {
      type: [Number, String, Array, Object],
      default() {
        return null;
      },
    },
  },

  data() {
    return {
      currentValue: this.value,
      itemSelected: false,
      cgiData: null,
    };
  },

  computed: {},

  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },
  },

  created() {
    this.fetchCgi();
  },

  mounted() {
    // 对所有的规则cell进行绑定，触发事件取消选中，与下面的onFocusItem对应
    Bus.$on('rule-item-blur', () => {
      this.itemSelected = false;
    });
  },

  methods: {
    validate() {
      return this.$refs.ruleContent.validate();
    },
    onFocusItem() {
      Bus.$emit('rule-item-blur');
      this.itemSelected = true;
    },
    onRemove() {
      this.$emit('remove');
    },
    onChangeComponent(value) {
      this.fetchCgi();
      console.log('change-component', value);
      this.$emit('change-component', {
        componentName: value.componentName,
        info: value,
        value: null,
      });
    },
    onChange(obj) {
      this.currentValue = obj.showVal;
      this.$emit('change', obj);
    },
    fetchCgi() {
      // 如果在组件初始化时，预加载的数据没有成功拉取，此处重新拉取一次
      if (RULE_TYPE_MAP[this.componentName].cgi) {
        if (this.preloadedData) {
          this.cgiData = this.preloadedData;
        } else {
          this.$ajax
            .get(RULE_TYPE_MAP[this.componentName].cgi)
            .then((res) => {
              this.cgiData = res;
            })
            .catch((err) => {
              const error = err || {};
              const msg = error.message || '接口请求出错';
              this.$message.error(msg);
            });
        }
      }
    },
  },
};
</script>
<style lang="less">
@import './style/style.less';
@import './components/conditionItemBase.less';
</style>
